import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowStep} from "../workflow-step";

@Component({
  templateUrl: "./add-additional-data.template.pug",
})

export class AddAdditionalDataComponent extends WorkflowStep {
  public siteId: string;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super();
  }

  public ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.siteId = workflowTargetInfo.targetId;

    this.workflowService.setStepStatus(WorkflowStepStatus.Completed, workflowTargetInfo.stepName);
  }
}
